// extracted by mini-css-extract-plugin
export var comparison = "sectionProductComparison-module--comparison--c6b35";
export var comparisonItem = "sectionProductComparison-module--comparisonItem--f22dd";
export var richtext = "sectionProductComparison-module--richtext--420b9";
export var section = "sectionProductComparison-module--section--ac630";